module.exports = __webpack_public_path__ + "img/folder-arrow-up.b2f81af8.svg";